import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../configs/axios";

const initialState = {
  userProfile: {},
};

export const userinfoProfile = createAsyncThunk(
  "users/fetchuserDetail",
  async () => {
    const response = await axios.get(`/user/profile`);
    return response.data;
  }
);

export const profileSlice = createSlice({
  name: "profile",
  initialState: initialState,
  reducers: {
    profileState: (state, action) => {
      state.userProfile = { ...state?.userProfile, ...action?.payload };
    },
    logoutUser: (state) => {
      state.userProfile = {};
    },
  },
  extraReducers(builder) {
    builder.addCase(userinfoProfile?.fulfilled, (state, action) => {
      state.userProfile = action?.payload?.data;
    });
  },
});

export const { profileState, logoutUser } = profileSlice.actions;

export default profileSlice;
